import { Component } from '@angular/core';

@Component({
	selector: 'app-setup-wizard-preview-job',
	imports: [],
	standalone: true,
	templateUrl: './setup-wizard-preview-job.html',
	styleUrl: './setup-wizard-preview-job.scss',
})
export class SetupWizardPreviewJob {}
